// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__vM0YL","Information":"Alert_Information__qOqq4","Warning":"Alert_Warning__WCI2V","Error":"Alert_Error__5atqD","Success":"Alert_Success__nz63b"};